import * as React from "react";

function SvgPlanetMurcury(props) {
  return (
    <svg viewBox="0 0 63.52 63.52" {...props}>
      <defs>
        <radialGradient
          id="planet-murcury_svg__d"
          cx={330.07}
          cy={-690.48}
          r={34.44}
          gradientTransform="matrix(.03 -.88 .91 -.16 633.47 194.77)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={0.67} stopColor="#515151" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="planet-murcury_svg__f"
          cx={330.07}
          cy={-690.48}
          r={34.44}
          gradientTransform="matrix(.03 -.88 .91 -.16 633.47 194.77)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#fdf5f6" />
          <stop offset={0.67} stopColor="#f7ebc2" />
          <stop offset={1} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-murcury_svg__a"
          x={2.66}
          y={-8181.6}
          width={37.78}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-murcury_svg__c"
          x={2.66}
          y={3.74}
          width={37.78}
          height={37.4}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <mask
          id="planet-murcury_svg__e"
          x={2.66}
          y={3.74}
          width={37.78}
          height={37.4}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-murcury_svg__b)"
            filter="url(#planet-murcury_svg__c)"
          >
            <path
              d="M10 10.45c8-7.69 20.81-9.19 27.52-2.3s.61 13.11-7 22.63c-6.3 7.81-17.12 14.35-23.83 7.46S2 18.15 10 10.45z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-murcury_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <path
          d="M63.52 31.76A31.76 31.76 0 111.74 21.38a30.85 30.85 0 012.11-4.78 31.76 31.76 0 0159.67 15.16z"
          fill="#eaa753"
        />
        <path
          d="M47.79 59.17a7.15 7.15 0 00-.26-1.71 7.59 7.59 0 00-4.24-4.88c-1.67-.72-3.63-.86-5-2a7.39 7.39 0 01-2.09-4.17 14.19 14.19 0 00-1.47-4.49c-.85-1.33-2.51-2.32-4-1.82a3.79 3.79 0 00-2.26 3.22 23 23 0 00.14 4.14 18.16 18.16 0 01-1.24 7c-1 2.7-2.71 5.43-5.45 6.35-.57.19-1.19.31-1.76.51a31.73 31.73 0 0027.67-2.14zM41.51 20.32a7.74 7.74 0 004.32-.8A4.41 4.41 0 0048.18 16a3.13 3.13 0 00-2.51-3.19c-2.05-.26-2.27 1.07-4.05 2.13a6.71 6.71 0 00-2.24 1.81 2.32 2.32 0 00-.11 2.71 3 3 0 002.24.86zM27.37 40a2.05 2.05 0 00-.86-1.38 4.46 4.46 0 00-3-1c-.51.06-.95 0-1.64 0a2.86 2.86 0 00-2.61 1.72 1.77 1.77 0 00-.11 1 5.46 5.46 0 001.26 2.53A8.71 8.71 0 0122 45.26c.26.8.25 1.68.53 2.47s1 1.56 1.85 1.4c.94-.8 1-2.21.95-3.45s-.1-2.62.72-3.55c.53-.64 1.46-1 1.32-2.13zM21 31.53a1.71 1.71 0 00-.64 2.34 1.64 1.64 0 002.91-1.48 1.71 1.71 0 00-2.27-.86zM17 3.71c-.13.27-.26.55-.38.82a9.27 9.27 0 00-1 3.41A3.43 3.43 0 0017 11c1 .63 2.39.47 3.45 1 1.72.93 1.94 3.26 2.89 5 1.5 2.71 5.08 3.82 8.1 3.07a12.62 12.62 0 007.17-5.59c1.14-1.74 2.07-3.71 3.75-4.93 2.33-1.7 5.86-1.78 7.75-3.75A31.58 31.58 0 0017 3.71z"
          fill="#c97832"
        />
        <path
          d="M60.86 22.5a6.42 6.42 0 00.84-1.34 31.91 31.91 0 00-5.55-9.73 17.48 17.48 0 00-4.29 1.68 6.86 6.86 0 00-3.3 4.12 13.92 13.92 0 01-.63 3.17c-1 2.11-3.89 2.26-6.23 2.35-1.45.06-3.31.65-3.3 2.09 0 1 1 1.68 1.88 2.07a14.27 14.27 0 008.16.71 43.51 43.51 0 007.92-2.47 10.77 10.77 0 004.5-2.65zM24.91 28.5a7 7 0 004.09-.26c1.26-.61 2.11-2.26 1.38-3.46a3.88 3.88 0 00-2.55-1.39 4.25 4.25 0 00-3.1 0 4.25 4.25 0 00-1.58 2.3 2.35 2.35 0 00-.15 1.8c.31.69 1.17.9 1.91 1.01zM36.94 23.22c.3-.19.7-.27.9-.57s-.05-1.07-.51-1.36a2.77 2.77 0 00-3.46.82 4.94 4.94 0 00-.79 3.7 3.43 3.43 0 00.65 1.76 1.59 1.59 0 001.7.56c.75-.49.79-1.56.75-2.45s0-1.97.76-2.46zM50.06 37.6c1-.7 2.12-1.16 3.08-1.89a3.53 3.53 0 001.6-3.07 3.32 3.32 0 00-3.14-2.5 15 15 0 00-4.28.63 18.48 18.48 0 01-7.26 0 18.35 18.35 0 00-3.86-.61A3.69 3.69 0 0032.92 32c-.75 1.49.1 3.31 1.26 4.5s2.66 2 3.65 3.39a14.38 14.38 0 011.91 5 8.15 8.15 0 002.59 4.63c1.45 1.08 3.88 1 4.74-.61.7-1.29.11-2.86-.07-4.32a7.62 7.62 0 013.06-6.99zM18.67 60.69a10.36 10.36 0 00.9-2.36 19.85 19.85 0 00.59-7.07 5.78 5.78 0 00-.65-2.43 2.44 2.44 0 00-2.05-1.29c-1.41 0-2.25 1.52-3.14 2.61A7.74 7.74 0 018 52.83a31.83 31.83 0 0010.67 7.86zM7.47 52.21zM28.41 36.68a1.67 1.67 0 002-.73 3.07 3.07 0 00.19-2.31c-.25-1-1-2-2-1.94a1.82 1.82 0 00-1.56 1.51 3.79 3.79 0 00.38 2.28 2.32 2.32 0 00.99 1.19zM63.52 31.76a31.05 31.05 0 00-.52-5.49 4 4 0 00-1.75 2.27c-1 2.55-1.36 5.29-2.28 7.86s-2.54 5.09-5.07 6.12c-1.35.54-3 .7-3.91 1.81-1.22 1.47-.55 3.68.18 5.44a8.23 8.23 0 002.45 3.75 4.24 4.24 0 001.59.68 31.69 31.69 0 009.31-22.44zM20.44 16.56c-.53-.25-1.25-.39-1.64 0a1.5 1.5 0 00-.28.78 5.3 5.3 0 00.26 3.08 2.39 2.39 0 002.55 1.4 2.31 2.31 0 001.45-2.81 4.11 4.11 0 00-2.34-2.45z"
          fill="#c97832"
        />
        <path
          d="M7.48 52.21l2.52-.33a2.82 2.82 0 00-2.52.33zM13.71 12.24a1.46 1.46 0 101.44 2.53 1.46 1.46 0 00-1.44-2.53zM11.61 14.41h-1.9a.3.3 0 010-.59h1.9a.3.3 0 010 .59zM13 11.89a.29.29 0 01-.28-.2 2.81 2.81 0 00-1.11-1.45.29.29 0 01-.08-.41.29.29 0 01.4-.08 3.32 3.32 0 011.34 1.76.29.29 0 01-.18.37zM18.24 13.78H17a.3.3 0 010-.59h1.27a.3.3 0 010 .59zM23.6 31a.26.26 0 01-.19-.07.3.3 0 010-.41l.65-.77a.29.29 0 01.41 0 .3.3 0 010 .41l-.65.78a.28.28 0 01-.22.06zM25.49 34.45a.18.18 0 01-.1 0l-.79-.31a.3.3 0 01-.17-.38.29.29 0 01.38-.16l.79.31a.3.3 0 01.17.38.31.31 0 01-.28.16zM15.55 17.72a.29.29 0 01-.29-.29v-1.26a.29.29 0 01.29-.29.3.3 0 01.3.29v1.26a.3.3 0 01-.3.29zM14.48 10.65l.15-1.27zM20 37.29h-.07a.29.29 0 01-.22-.35l.29-1.28a.29.29 0 01.35-.21.31.31 0 01.22.36l-.32 1.26a.29.29 0 01-.25.22zM20.46 30.5a.32.32 0 01-.26-.15l-.27-.5a.29.29 0 01.11-.4.3.3 0 01.4.12l.27.49a.29.29 0 01-.11.4.25.25 0 01-.14.04zM23.26 37.37a.3.3 0 01-.29-.21l-.3-1.16a.29.29 0 01.2-.36.29.29 0 01.36.21l.31 1.15a.29.29 0 01-.21.35z"
          fill="#c97832"
        />
        <path
          d="M15.7 13.18a.4.4 0 000-.11 1.6 1.6 0 00-.1-.23 1.51 1.51 0 00-1.89-.6 1.37 1.37 0 00-.65.67.59.59 0 000 .14 1.6 1.6 0 012.64.13z"
          fill="#995d2e"
        />
        <path
          d="M29.31 35.6a1.38 1.38 0 00.1-2.58 1.37 1.37 0 10-.1 2.58zM45.33 14c-.79-.06-1.4.64-1.95 1.21A9.32 9.32 0 0141 17.06a3.6 3.6 0 00-1 .69 1 1 0 00-.19 1.13 1.37 1.37 0 001.23.44 8 8 0 003.69-.64 3.34 3.34 0 002-3 1.66 1.66 0 00-1.4-1.68zM21.79 53.39c-.18 1-.34 2.09-.5 3.13a1 1 0 00.13.83c.27.28.73.15 1.07 0a6.3 6.3 0 002.64-2.72 3.45 3.45 0 00.36-2.63 1.87 1.87 0 00-2-1.33c-1.12.33-1.49 1.61-1.7 2.72zM36.82 22.25a2.27 2.27 0 00-1.35 4.3 6.92 6.92 0 011.35-4.3zM22.78 19.05a4.11 4.11 0 00-2.34-2.49c-.53-.25-1.25-.39-1.64 0a1.5 1.5 0 00-.28.78 5.05 5.05 0 00-.08.68 4 4 0 014.41 1.45 2.32 2.32 0 00-.07-.42zM21.6 41.5c.26.54.86.83 1.24 1.31a4.63 4.63 0 01.59 2.57c.07.89-.09 1 .74 1.37-.26-1.7.33-2.59.84-4.24a10.79 10.79 0 00.49-1.77 2.18 2.18 0 00-.43-1.74 1.83 1.83 0 00-1.9-.46 2.57 2.57 0 00-1.47 1.37 1.85 1.85 0 00-.1 1.59zM30.42 24.78a3.88 3.88 0 00-2.55-1.39 4.25 4.25 0 00-3.1 0 3.38 3.38 0 00-1.3 1.64 5.53 5.53 0 013.53-.89 8.06 8.06 0 013.63 1.26 1.87 1.87 0 00-.21-.62zM53.79 37.46a.87.87 0 10.26-.14zM51.18 41.58a1.29 1.29 0 001 1 1.27 1.27 0 001.29-.58 1.26 1.26 0 10-2.29-.37zM38.87 29.52a1.89 1.89 0 00.13-1.88 1.12 1.12 0 10-.12 1.88zM31.24 37.27a1 1 0 00.83 1.16 1 1 0 10-.83-1.16z"
          fill="#b36225"
        />
        <path
          d="M16.43 45a.76.76 0 00-.1.75.85.85 0 00.58.32l3.29.82a1.85 1.85 0 00.19-2.2 2.14 2.14 0 00-2-1A2.59 2.59 0 0016.43 45zM35.78 40.57a.64.64 0 00.34-.88.6.6 0 10-.88.79.65.65 0 00.54.09zM46.57 51.58a2.09 2.09 0 001.34 2 1.65 1.65 0 002.05-1 1.72 1.72 0 00-.23-1.29 2.11 2.11 0 00-2.38-.93c-.88.23-.78.3-.78 1.22zM49.87 8.17a1.32 1.32 0 00-.84.45 1.47 1.47 0 00-.31.76 2 2 0 00.79 1.71 1.67 1.67 0 002 .14A1.48 1.48 0 0052 9.78a2.18 2.18 0 00-1-1.26 1.78 1.78 0 00-1.13-.35z"
          fill="#c97832"
        />
        <path
          d="M47.25 10.61a.64.64 0 00-.17-.77 1.82 1.82 0 00-.77-.36c-.38-.09-.89-.12-1.05.23a.6.6 0 00.15.62 1.89 1.89 0 00.56.35 2.37 2.37 0 00.67.21.66.66 0 00.61-.28zM48.89 13.55a.61.61 0 001-.59.62.62 0 00-1.21 0 .65.65 0 00.21.59zM24.15 20.06a1 1 0 00-.15 1.58 1 1 0 001.22-.06.93.93 0 00-1-1.52z"
          fill="#b36225"
        />
        <path
          d="M1.74 21.38a31.79 31.79 0 003.64 28.07 19.71 19.71 0 004.07-1.8 28.13 28.13 0 005.47-3.57 9.34 9.34 0 003.2-5.55c.37-2.76-.79-6 1.09-8.09.79-.91 2.11-1.32 2.79-2.44a1.74 1.74 0 00.2-1.37c-.4-1.36-2.18-1.25-3.34-1.9A5 5 0 0116.91 22a6.86 6.86 0 00-1.65-3c-.86-.74-2.38-.86-3 .08v-.17a3 3 0 00-2.67-2.52 3.88 3.88 0 01-2.15-1.08 6 6 0 01-1.31-2.24 31.25 31.25 0 00-4.34 8.29z"
          fill="#c97832"
        />
        <path
          d="M29.4 39.23a.3.3 0 01-.23-.11.29.29 0 01.06-.4l.92-.7a.28.28 0 01.39.06.27.27 0 01-.05.39l-.92.7a.29.29 0 01-.17.06zM33.81 39.49a.28.28 0 01-.25-.16l-.35-.69a.29.29 0 01.13-.38.28.28 0 01.38.13l.34.69a.28.28 0 01-.12.38.28.28 0 01-.13.03zM33.24 36.36h-.06a.3.3 0 01-.22-.2.52.52 0 01.32-.58l.2-.25a.28.28 0 01.27-.1.28.28 0 01.22.2.51.51 0 01-.32.58l-.2.25a.25.25 0 01-.21.1zM49.58 43.14a.27.27 0 01-.26-.17.28.28 0 01.14-.37l.91-.39a.28.28 0 01.37.14.29.29 0 01-.15.37l-.9.4zM50.69 40.42a.3.3 0 01-.24-.12l-.2-.3a.76.76 0 01-.31-.5.28.28 0 01.18-.31.27.27 0 01.33.1l.21.31a.68.68 0 01.28.4.23.23 0 010 .14.29.29 0 01-.29.28zM53.59 40.3h-.12a.28.28 0 01-.13-.38 1.45 1.45 0 01.87-.72.28.28 0 01.35.19.29.29 0 01-.19.35.86.86 0 00-.52.43.29.29 0 01-.26.13zM51.38 44.81a.27.27 0 01-.25-.31l.11-1a.29.29 0 01.31-.25.28.28 0 01.25.31l-.11 1.05a.29.29 0 01-.31.2z"
          fill="#b36225"
        />
        <path
          d="M26.51 49.19a.73.73 0 000 1.21 1 1 0 001.31-.31 1.76 1.76 0 00.24-1.42.88.88 0 00-1.41.34z"
          fill="#c97832"
        />
        <path
          d="M42.66 34.54a7.75 7.75 0 015.21-1.85 3.94 3.94 0 012.18.38 1.54 1.54 0 01.7 1.92A7.82 7.82 0 0045 44.44a3.71 3.71 0 01.2 1.47 1 1 0 01-1 .86c-.39-.08-.63-.47-.81-.83a19.27 19.27 0 01-2.23-5.69 6.55 6.55 0 011.5-5.71z"
          fill="#b36225"
        />
        <path
          d="M6.67 12.36a26.27 26.27 0 11-1.56 2.21 31.77 31.77 0 101.56-2.21z"
          fill="#bd6420"
          opacity={0.54}
        />
        <path
          d="M49.22 48.4a33.07 33.07 0 01-38.76 6.92 31.83 31.83 0 0044.48-1.79 31.32 31.32 0 00-1.42-44.48l-.43-.38a32.51 32.51 0 01-3.87 39.73z"
          style={{
            mixBlendMode: "multiply",
          }}
          fill="#b89e8f"
        />
        <path
          d="M12.15 56.74a5.07 5.07 0 00-.45-5.3 9.23 9.23 0 00-5-3.21 23.86 23.86 0 00-2.37-.53 32.14 32.14 0 007.82 9.04zM6.93 42.62c3.07-.93 5.39-3.45 7.15-6.14A11.28 11.28 0 0016.21 31c.15-3.3-2.15-6.3-5-8a38 38 0 01-4.48-2.7 4.84 4.84 0 01-2-4.57 7.17 7.17 0 00-.76.57c-.06.12-.14.24-.2.36a30.85 30.85 0 00-2.11 4.78A31.79 31.79 0 001.8 42.3a7.6 7.6 0 005.13.32zM58.24 18a9 9 0 01-3.38 5.88 22.78 22.78 0 00-3.38 2.51c-.93 1.06-1.3 2.83-.3 3.81.82.8 2.16.8 2.82 1.74a10 10 0 01.53 2.06A2.92 2.92 0 0057 35.7a5.66 5.66 0 003-.7 11.38 11.38 0 003.48-2.64v-.61a31.65 31.65 0 00-4.58-16.43 6.12 6.12 0 00-.66 2.68zM24.58 61a2.77 2.77 0 00-.81 1.46c.63.17 1.27.31 1.92.43zM54.4 54a2.3 2.3 0 00-1-.62 3.83 3.83 0 00-3.24 1 18.56 18.56 0 01-2.76 2.17c-2.23 1.15-4.92.34-7.32-.4s-5.23-1.29-7.24.21c-1.4 1-2 2.8-2.75 4.36a7.3 7.3 0 01-1.91 2.57 33.35 33.35 0 003.62.21A31.64 31.64 0 0054.4 54z"
          fill="#b36225"
        />
        <path
          d="M3.85 16.6a30.85 30.85 0 00-2.11 4.78 31.82 31.82 0 001.1 23.52c11.36 3 23-.73 31.61-9.87 8.84-9.38 12-22 7.84-33.23A31.79 31.79 0 003.85 16.6z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-murcury_svg__e)">
          <path
            d="M10 10.45c8-7.69 20.81-9.19 27.52-2.3s.61 13.11-7 22.63c-6.3 7.81-17.12 14.35-23.83 7.46S2 18.15 10 10.45z"
            opacity={0.57}
            fill="url(#planet-murcury_svg__f)"
          />
        </g>
        <path
          d="M50.86 6.4a32.12 32.12 0 00-4.2-2.66A31.66 31.66 0 0037.15.48l-.94-.15-.85-.11-.7-.07-1.08-.08h-1.87A31.69 31.69 0 0019.2 2.64a31.42 31.42 0 0126.21 1.47 31 31 0 0112.86 42.16 31.47 31.47 0 01-42.41 12.85c-.88-.47-1.72-1-2.53-1.5a31.74 31.74 0 007 3.75 32 32 0 0039.42-14.74 31.47 31.47 0 003.63-11.91l.06-.82v-.61-1.53A31.68 31.68 0 0050.86 6.4z"
          style={{
            mixBlendMode: "screen",
          }}
          fill="#fff"
          opacity={0.24}
        />
      </g>
    </svg>
  );
}

export default SvgPlanetMurcury;
